import { initialTraits, type InputTraits } from './traits';

/**
 * **当前输入画像的全局来源。**
 *
 * 和 i18n 的 `t()` 同一个套路：控件太多，把 `traits` 参数穿过每一个控件签名
 * 会把每个 API 污染一遍。`main.ts` 启动时 `setTraitsSource(() => profile.traits())`，
 * 于是 `state.ts` 这类底层控件直接 `currentTraits()` 取用。
 */
let source: (() => InputTraits) | null = null;

export function setTraitsSource(next: (() => InputTraits) | null): void {
  source = next;
}

/**
 * 没接 profile 时的默认画像：**当作桌面**（能 hover、精确指针）。
 * 这样测试、调试页、以及还没接线的路径不会被误判成触屏。
 */
const ASSUMED: InputTraits = { ...initialTraits(), canHover: true, finePointer: true };

/** 当前画像。没接线时给桌面默认 */
export function currentTraits(): InputTraits {
  return source?.() ?? ASSUMED;
}

/**
 * **现在这个输入能不能 hover。**
 *
 * 装饰性的 hover（抬起、变墨、让位、高亮）在触控/无 hover 指针上**一律不生效** ——
 * 浏览器在点完之后还会把指针位置留在原地，照着它算 hover 会让这些地方
 * 反复进入/退出（表现为抽搐）。功能性的东西（tooltip）另走点按 / 长按。
 */
export function canHoverNow(): boolean {
  return currentTraits().canHover;
}
